var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCards({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.87,25.64v.72a2.36,2.36,0,0,1-2.35,2.36H12.75a2.36,2.36,0,0,1-2.36-2.36V16.8a2.36,2.36,0,0,1,2.36-2.35H26.52a2.35,2.35,0,0,1,2.35,2.35v.72",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.15,14.21l3.23-4a2.17,2.17,0,0,1,3.5,0l.75.92",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15,14.21l3.23-4a2.18,2.18,0,0,1,3.51,0l3.22,4",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4,18.22H25.25a3.37,3.37,0,0,0-3.36,3.36h0a3.37,3.37,0,0,0,3.36,3.36H29.4a1.21,1.21,0,0,0,1.21-1.21v-4.3A1.22,1.22,0,0,0,29.4,18.22Z",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.51,20.19a1.4,1.4,0,1,0,1.39,1.39A1.4,1.4,0,0,0,25.51,20.19Z",
    fill: "none",
    stroke: "#624de3",
    strokeMiterlimit: 10,
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.7e907c57729abf9394fe6cadefd68532.svg";
export { ForwardRef as ReactComponent };